<template>
    <div class="flex justify-around items-center gap-2.5 -mx-5 -mb-4 mt-auto sticky bottom-0 left-0 right-0 max-h-[60px] min-h-[60px] bg-[#2D3645] rounded-t-2xl z-10 [&>svg]:size-5 [&>svg]:cursor-pointer text-[#D6D6E3]">
            <icon-svg name="category"/>
            <icon-svg name="calendar"/>
            <icon-svg name="community" class="!size-7"/>
            <icon-svg name="burger"/>
        </div>
</template>

<script>

export default {
    name: 'v-navigation'
}

</script>